export default function HeadingSkeleton(): JSX.Element {
    return <div className="sk-heading animate-pulse"></div>;
  }